export const CONFIG_API_URLS = process.env.CONFIG_API_URLS;
export const CONFIG_WSS_URLS = process.env.CONFIG_WSS_URLS;
export const APP_API_FALLBACK_ENABLED = process.env.APP_API_FALLBACK_ENABLED;
export const KEY_HOST_CACHE_API = 'SM_host_cache_api';
export const KEY_HOST_CACHE_NEXT_API = 'SM_host_cache_next_api';
export const KEY_HOST_CACHE_ERROR_LAST_API = 'SM_host_cache_error_last_api';

export const parseUrlsApi = (_config) => {
    if (!_config) return {};

    const options = _config.split('|');
    const config = options.reduce((state, _item) => {
        const item = _item.split('%');

        if (item.length === 2) {
            const key = item[0];
            const value = item[1];

            state[key] = value;
        }

        return state;
    }, {});

    return config;
};

export const get_url_api = (default_url) => {
    const host = get_host_cache();
    const api_url = parseUrlsApi(CONFIG_API_URLS)[host];

    if (api_url) return api_url + '/v5/';

    return default_url;
};

export const get_url_wss = (default_url) => {
    const host = get_host_cache();
    const wss_url = parseUrlsApi(CONFIG_WSS_URLS)[host];

    if (wss_url) return wss_url;

    return default_url;
};

export const get_host_cache = () => {
    const host = window.location.host;
    const host_cache = window.localStorage.getItem(KEY_HOST_CACHE_API);

    if (APP_API_FALLBACK_ENABLED) {
        return host_cache || host;
    }

    remove_all_host_cache();

    return host;
};

export const is_api_error_last_cache = () =>
    Boolean(window.localStorage.getItem(KEY_HOST_CACHE_ERROR_LAST_API));

export const set_host_error_last_cache = (value) => {
    window.localStorage.setItem(KEY_HOST_CACHE_ERROR_LAST_API, value);
};

export const set_host_cache = (value) => {
    window.localStorage.setItem(KEY_HOST_CACHE_API, value);
};

export const remove_all_host_cache = () => {
    window.localStorage.removeItem(KEY_HOST_CACHE_API);
    window.localStorage.removeItem(KEY_HOST_CACHE_NEXT_API);
    window.localStorage.removeItem(KEY_HOST_CACHE_ERROR_LAST_API);
};
